import { render, staticRenderFns } from "./UIdevelopmentproject.vue?vue&type=template&id=683567d8"
import script from "./UIdevelopmentproject.vue?vue&type=script&lang=js"
export * from "./UIdevelopmentproject.vue?vue&type=script&lang=js"
import style0 from "./UIdevelopmentproject.vue?vue&type=style&index=0&id=683567d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports